import Eyebrow from "./Eyebrow";
import ProfileFlipCard from "./ProfileFlipCard";

const AboutSection = () => (
  <section id="about" className="border-b py-16 sm:py-20 lg:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 space-y-12 lg:space-y-16">

      <div className="space-y-2">
        <Eyebrow>Über mich</Eyebrow>
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight">
          Support, der beim Menschen beginnt
        </h2>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">

        {/* Text */}
        <div className="space-y-5 text-muted-foreground text-base leading-relaxed">
          <p>
            Mein Antrieb ist eine hochwertige Customer Experience. Guter Support
            hört für mich nicht bei der Lösung auf: Ich denke die ganze Customer
            Journey mit, vom ersten Kontakt bis zur Rückmeldung, und erkläre
            Technik so, dass sie verständlich wird. Ob auf Deutsch oder Englisch.
          </p>
          <p>
            Die Grundlage dafür habe ich bei Apple Retail gelegt, in der direkten
            Kundenberatung. Danach folgten der internationale Service Desk bei
            CSL Behring mit Mitarbeitenden in Europa, den USA und Australien und
            fünf Jahre als Single Point of Contact im 1st-/2nd-Level-Support bei
            Isolutions, für Kunden aus der Banken- und Energiebranche.
          </p>
          <p>
            Technisch bringe ich breite Erfahrung in der Microsoft-365-Administration
            mit: Exchange Online, Teams, SharePoint, Intune und Azure AD. So kann
            ich Anliegen nicht nur entgegennehmen, sondern oft direkt selbst lösen.
          </p>
        </div>

        {/* Interactive profile flip card */}
        <ProfileFlipCard className="max-w-xs mx-auto lg:mx-0 lg:ml-auto" />
      </div>
    </div>
  </section>
);

export default AboutSection;
